export function formatDateLocalized(dateInput, t) {
    if (!dateInput) return "";
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return "";
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    const months = t("months", { returnObjects: true });
    const monthName = Array.isArray(months) ? months[monthIndex] : String(monthIndex + 1).padStart(2, "0");
    return `${day} ${monthName} ${year}`;
}
